export const defaultEventDomain = 'browser';